<!-- Classes main-div and example-card are catagorized in .css file -->
<div class="login-header">
  <div class="language-item row">
    <button type="button" class="select-language" [matMenuTriggerFor]="menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
      <div>
        <img *ngIf="currentLanguage == 'vi'" class="vt-cursor-pointer" src="../../../assets/images/vn.svg" alt="vietnamese" width="30" height="20">
        <img *ngIf="currentLanguage == 'en'" class="vt-cursor-pointer" src="../../../../assets/images/en.svg" alt="english" width="30" height="20">
        <img *ngIf="currentLanguage == 'zh'" class="vt-cursor-pointer" src="../../../assets/images/china.svg" alt="china" width="30" height="20">
        <img *ngIf="currentLanguage == 'es'" class="vt-cursor-pointer" src="../../../assets/images/es.svg" alt="china" width="30" height="20">
      </div>
      <span class="">{{getCurrentNameLanguage()}}</span>
      <div class="">
          <em *ngIf="isOpen" class="material-icons">keyboard_arrow_up</em>
          <em *ngIf="!isOpen" class="material-icons">keyboard_arrow_down</em>
      </div>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onChangeLanguage('vi')" style="width: 140px;"
          [ngClass]="{'active-btn': currentLanguage == 'vi'}">
          <img class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
          {{'Tiếng Việt' | translate}}
      </button>
      <button mat-menu-item (click)="onChangeLanguage('en')" style="width: 140px;"
          [ngClass]="{'active-btn': currentLanguage == 'en'}">
          <img class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
          {{'English' | translate}}
      </button>
      <button mat-menu-item (click)="onChangeLanguage('zh')" style="width: 140px;"
          [ngClass]="{'active-btn': currentLanguage == 'zh'}">
          <img class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
          {{'中国人' | translate}}
      </button>
      <button mat-menu-item (click)="onChangeLanguage('es')" style="width: 140px;"
          [ngClass]="{'active-btn': currentLanguage == 'es'}">
          <img class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
          {{'Español' | translate}}
      </button>
    </mat-menu>
  </div>
</div>
<div class="login-wrapper">
  <mat-card class="login-card" [hidden]="currentStep !== 1">
    <form name="form1" #f1="ngForm" (ngSubmit)="f1.form.valid && nextStep()">
      <mat-card-header>
        <div mat-card-avatar class="text-center" style="padding-bottom: 1.5rem;">
          <img alt="Logo" src="../../../../assets/images/logo_vcontract.png" width="46%">
          <div _ngcontent-yva-c7="" class="vt-text-login-header text-center">{{'login_page.title_forgot_password' | translate}}</div>
          <span>{{'login_page.sub_title_1' | translate}}</span>
        </div>
      </mat-card-header>
      <mat-card-content class="pt-2">
        <mat-form-field class="w-100">
          <mat-label>{{'login_page.lbl_username' | translate}}</mat-label>
          <input (focusout)="username = username.trim()" #focusInput matInput
            placeholder="{{'login_page.enter_username' | translate}}" name="usernameCtrl" #usernameCtrl="ngModel"
            [(ngModel)]="username" maxlength="100" required
            [ngClass]="{ 'is-invalid': usernameCtrl.invalid && f1.submitted }">
          <mat-error *ngIf="usernameCtrl.invalid || f1.submitted">
            <span *ngIf="usernameCtrl?.errors?.required">{{'validation.username' | translate}}</span>
          </mat-error>
        </mat-form-field>
      </mat-card-content>
      
      <mat-card-actions class="mb-0 text-center">
        <button class="ml-2" mat-stroked-button color="primary" type="button" (click)="cancel()">
          {{'button.cancel' | translate}}
        </button>
        <!-- <button mat-raised-button style="margin-bottom: 10px !important" color="primary" type="submit" appTrackEvent="w.btn.gui_yeu_cau_khoi_phuc_mat_khau">
          {{'alert.reset_password' | translate}}
        </button> -->
        <button mat-raised-button style="margin-bottom: 10px !important" color="primary" type="submit">
          {{'button.next' | translate}}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
  <mat-card [hidden]="currentStep !== 2" class="login-card">
    <form name="form2" #f2="ngForm" (ngSubmit)="f2.form.valid && nextStep()">
      <mat-card-header>
        <div mat-card-avatar class="text-center position-relative" style="padding-bottom: 1.5rem;">
          <img alt="Logo" src="../../../../assets/images/logo_vcontract.png" width="46%">
          <div _ngcontent-yva-c7="" class="vt-text-login-header text-center">{{'login_page.title_forgot_password' | translate}}</div>
          <span>{{'login_page.sub_title_2' | translate}}</span>
          <div style="color: #727272;">
            <div class="mt-3 mb-1">{{'login_page.sub_title_3' | translate}}:</div>
            <div style="width: fit-content; text-align: left; margin: auto;">
              <div>&#8226; {{'Email' | translate}}: {{userEmail}}</div>
              <div>&#8226; {{'headertable.phone' | translate}}: {{userPhone}}</div>
            </div>
          </div>
          <button mat-icon-button type="button" style="top: 0; left: 0;" (click)="backStep();" class="position-absolute">
            <mat-icon>arrow_back_ios</mat-icon>
          </button>
        </div>
      </mat-card-header>
  
      <mat-card-content>
        <mat-form-field class="w-100">
          <mat-label>{{'form.login_email' | translate}}</mat-label>
          <input type="text" (focusout)="email= email.trim()" matInput
            placeholder="{{'form.login_email' | translate}}" name="emailCtrl" #emailCtrl="ngModel"
            [ngClass]="{ 'is-invalid': emailCtrl.invalid && f2.submitted }" [(ngModel)]="email" maxlength="100"
            required [pattern]="emailPattern">
          <mat-error *ngIf="emailCtrl.invalid || f2.submitted">
            <span *ngIf="emailCtrl?.errors?.required">{{'validation.email_phone_number' | translate}}</span>
            <span *ngIf="emailCtrl?.errors?.pattern" class="text-error">{{'validation.email_phone_number_format' | translate}}
            </span>
          </mat-error>
        </mat-form-field>
      </mat-card-content>
      
      <mat-card-actions class="mb-0 text-center">
        <button class="ml-2" mat-stroked-button color="primary" type="button" (click)="cancel()">
          {{'button.cancel' | translate}}
        </button>
        
        <button mat-raised-button style="margin-bottom: 10px !important" color="primary" type="submit">
          {{'login_page.send_otp' | translate}}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
  <mat-card [hidden]="currentStep !== 3" class="login-card">
    <form name="form3" #f3="ngForm" [mustMatch]="['newPasswordCtrl', 'confirmNewPasswordCtrl']" (ngSubmit)="f3.form.valid && nextStep()">
      <mat-card-header>
        <div mat-card-avatar class="text-center position-relative" style="padding-bottom: 1.5rem;">
          <img alt="Logo" src="../../../../assets/images/logo_vcontract.png" width="46%">
          <div _ngcontent-yva-c7=""  class="vt-text-login-header text-center">{{'login_page.title_reset_password' | translate}}</div>
          <button mat-icon-button type="button" style="top: 0; left: 0;" (click)="backStep();" class="position-absolute">
            <mat-icon>arrow_back_ios</mat-icon>
          </button>
        </div>
      </mat-card-header>
      
      <mat-card-content>
        <mat-form-field class="w-100">
          <mat-label>{{'login_page.new_password' | translate}}</mat-label>
          <button matSuffix mat-icon-button color="primary" type="button" (click)="showNewPassword = !showNewPassword">
            <mat-icon>{{!showNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input [type]="showNewPassword ? 'text' : 'password'" (focusout)="newPassword= newPassword.trim()" matInput
            placeholder="{{'login_page.enter_password' | translate}}" name="newPasswordCtrl" #newPasswordCtrl="ngModel"
            [ngClass]="{ 'is-invalid': newPasswordCtrl.invalid && f3.submitted}" [(ngModel)]="newPassword" (ngModelChange)="validateNewPassWord();" maxlength="100"
            required autocomplete="new-password">
          <mat-hint>
            <div class="mat-error" *ngIf="(!newPassword && newPasswordCtrl?.touched) || f3.submitted">
              <span *ngIf="newPasswordCtrl?.errors?.required">{{'login_page.new_password_required' | translate}}</span>
            </div>
            <div *ngIf="newPassword">
              <span>{{'login_page.sub_validate_password_1' | translate}}:</span>
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <span *ngIf="currentValidate.minLength">
                    <ng-container *ngTemplateOutlet="icon_check"></ng-container>
                  </span>
                  <span *ngIf="!currentValidate.minLength">
                    <ng-container *ngTemplateOutlet="icon_x"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_2' | translate}}
                </div>
                <div class="col-md-6 col-sm-12">
                  <span *ngIf="currentValidate.hasUppercase">
                    <ng-container *ngTemplateOutlet="icon_check"></ng-container>
                  </span>
                  <span *ngIf="!currentValidate.hasUppercase">
                    <ng-container *ngTemplateOutlet="icon_x"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_3' | translate}}
                </div>
                <div class="col-md-6 col-sm-12">
                  <span *ngIf="currentValidate.hasLowercase">
                    <ng-container *ngTemplateOutlet="icon_check"></ng-container>
                  </span>
                  <span *ngIf="!currentValidate.hasLowercase">
                    <ng-container *ngTemplateOutlet="icon_x"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_4' | translate}}
                </div>
                <div class="col-md-6 col-sm-12">
                  <span *ngIf="currentValidate.hasNumber">
                    <ng-container *ngTemplateOutlet="icon_check"></ng-container>
                  </span>
                  <span *ngIf="!currentValidate.hasNumber">
                    <ng-container *ngTemplateOutlet="icon_x"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_5' | translate}}
                </div>
                <div class="col-md-6 col-sm-12">
                  <span *ngIf="currentValidate.hasSpecialChar">
                    <ng-container *ngTemplateOutlet="icon_check"></ng-container>
                  </span>
                  <span *ngIf="!currentValidate.hasSpecialChar">
                    <ng-container *ngTemplateOutlet="icon_x"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_6' | translate}}
                </div>
              </div>
            </div>
            <div *ngIf="!newPassword">
              <span>{{'login_page.sub_validate_password_1' | translate}}:</span>
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <span>
                    <ng-container *ngTemplateOutlet="icon_null"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_2' | translate}}
                </div>
                <div class="col-md-6 col-sm-12">
                  <span>
                    <ng-container *ngTemplateOutlet="icon_null"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_3' | translate}}
                </div>
                <div class="col-md-6 col-sm-12">
                  <span>
                    <ng-container *ngTemplateOutlet="icon_null"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_4' | translate}}
                </div>
                <div class="col-md-6 col-sm-12">
                  <span>
                    <ng-container *ngTemplateOutlet="icon_null"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_5' | translate}}
                </div>
                <div class="col-md-6 col-sm-12">
                  <span>
                    <ng-container *ngTemplateOutlet="icon_null"></ng-container>
                  </span>
                  {{'login_page.sub_validate_password_6' | translate}}
                </div>
              </div>
            </div>
          </mat-hint>
        </mat-form-field>
        
        <mat-form-field class="w-100">
          <mat-label>{{'login_page.confirm_new_password' | translate}}</mat-label>
          <button matSuffix mat-icon-button color="primary" type="button" (click)="showConfirmNewPassword = !showConfirmNewPassword">
            <mat-icon>{{!showConfirmNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input
            [type]="showConfirmNewPassword ? 'text' : 'password'"
            matInput
            autocomplete="new-password"
            name="confirmNewPasswordCtrl"
            #confirmNewPasswordCtrl="ngModel"
            [(ngModel)]="confirmNewPassword"
            required
            maxlength="100" 
            [class.is-invalid]="confirmNewPasswordCtrl.invalid && f3.submitted"
            placeholder="{{'login_page.enter_password' | translate}}"
          />

          <mat-error *ngIf="confirmNewPasswordCtrl.errors?.required || (f3.submitted && !confirmNewPassword)">
            {{'login_page.confirm_new_password_required' | translate}}
          </mat-error>
          <mat-error *ngIf="newPassword && confirmNewPassword && confirmNewPasswordCtrl.errors?.mustMatch">
            {{'login_page.confirm_new_password_match' | translate}}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <mat-label>{{'login_page.verify_code' | translate}}</mat-label>
          <input
            type="text"
            matInput
            name="verifyCodeCtrl"
            #verifyCodeCtrl="ngModel"
            [(ngModel)]="verifyCode"
            style="padding-right: 96px;"
            required
            maxlength="100" 
            [class.is-invalid]="verifyCodeCtrl.invalid && f3.submitted"
            placeholder="{{'login_page.enter_verify_code' | translate}}"
            autocomplete="off"
          />
          <mat-error *ngIf="verifyCodeCtrl.errors?.required || f3.submitted">
            {{'login_page.verify_code_required' | translate}}
          </mat-error>
          <div class="position-absolute" style="top: 10px; right: 0;">
            <span *ngIf="resetTimeVerifyCode !== 0">{{'login_page.send_again_later' | translate}} <span class="text-danger">{{resetTimeVerifyCode}}(s)</span></span>
            <span (click)="resetOTP()" style="cursor: pointer; text-decoration: underline;" class="text-danger" *ngIf="resetTimeVerifyCode === 0">{{'login_page.resend_code' | translate}}</span>
          </div>
        </mat-form-field>
        <div style="font-style: italic;">{{'login_page.sub_title_4' | translate}} <span class="text-danger">{{expireTimeVerifyCode}}(s)</span></div>
      </mat-card-content>
      <mat-card-actions class="mb-0 text-center">
        <button class="ml-2" mat-stroked-button color="primary" type="button" (click)="cancel()">
          {{'button.cancel' | translate}}
        </button>
        
        <button mat-raised-button style="margin-bottom: 10px !important" color="primary" type="submit">
          {{'login_page.btn_reset_password' | translate}}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>

<div class="login-footer">
  <div class="container-fluid py-3">
    <div class="row">
      <div class="col-12">
        <h5 class="text-white">{{'footer.contact' | translate}}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-3 text-overflow-ellipsis">
        {{'footer.hot_line' | translate}} {{phoneNumber}}<br>{{'footer.email_detail' | translate}}
      </div>
      <div class="col-5 text-overflow-ellipsis">
        <!-- {{'footer.text_owner' | translate}}<br>{{'footer.paper' | translate}} -->
      </div>
      <div class="col-4 text-right text-overflow-ellipsis">
        {{'footer.copy-right' | translate}}<br>{{'footer.powered' | translate}}
      </div>
    </div>
  </div>
</div>

<ng-template #icon_check>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" fill="#58B84F"/>
    <path d="M8.01516 4.48483C8.16161 4.63128 8.16161 4.86872 8.01516 5.01516L5.51517 7.51517C5.36872 7.66161 5.13128 7.66161 4.98483 7.51517L3.98483 6.51517C3.83839 6.36872 3.83839 6.13128 3.98483 5.98483C4.13128 5.83839 4.36872 5.83839 4.51517 5.98483L5.25 6.71967L6.36742 5.60225L7.48483 4.48483C7.63128 4.33839 7.86872 4.33839 8.01516 4.48483Z" fill="white"/>
  </svg>
</ng-template>

<ng-template #icon_x>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" fill="#D11313"/>
    <path d="M4.48483 4.48483C4.63128 4.33839 4.86872 4.33839 5.01516 4.48483L6.00001 5.46968L6.98483 4.48485C7.13128 4.3384 7.36872 4.3384 7.51517 4.48485C7.66161 4.63129 7.66161 4.86873 7.51517 5.01518L6.53034 6.00001L7.51515 6.98482C7.6616 7.13127 7.6616 7.36871 7.51515 7.51516C7.36871 7.6616 7.13127 7.6616 6.98482 7.51516L6.00001 6.53034L5.01518 7.51516C4.86873 7.66161 4.63129 7.66161 4.48485 7.51516C4.3384 7.36872 4.3384 7.13128 4.48485 6.98484L5.46967 6.00001L4.48483 5.01516C4.33839 4.86872 4.33839 4.63128 4.48483 4.48483Z" fill="white"/>
  </svg>
</ng-template>

<ng-template #icon_null>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1847_5336)">
    <circle cx="6" cy="6" r="5" stroke="#252728" stroke-width="0.75"/>
    </g>
    <defs>
    <clipPath id="clip0_1847_5336">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
  </svg>    
</ng-template>

<ng-template #errorDialog>
    <div class="margin-50">
      <div *ngIf="errorMessage1" class="text-center">
        <img src="./assets/images/warning_icon.png" alt="">
      </div>
      <div *ngIf="!errorMessage1" class="text-center">
        <img src="./assets/images/noti_icon.png" alt="">
      </div>
      
      <div style="width: 100%; margin: 16px 0;">
        <div style="color: #252728;font-weight: 600;font-size: 18px;"  class="text-center">
          {{(errorMessage1 ? 'dialog_warning' : 'login_page.title_success') | translate}}
        </div>
        <div *ngIf="errorMessage1" style="text-align: center; font-size: medium; overflow-wrap: break-word;;">
          {{ errorMessage1 | translate }}
        </div>
        <div *ngIf="!errorMessage1" style="text-align: center; font-size: medium; overflow-wrap: break-word;">
          {{ 'login_page.toast_success' | translate}}
        </div>
      </div>
    </div>
    <div class="justify-content-center" mat-dialog-actions>
      <button class="margin-50" mat-raised-button (click)="closeErrorDialog()" style="width: 100%;"   color="primary">
        {{(errorMessage1 ? 'button.close' : "button.accept") | translate}}
      </button>
    </div>
</ng-template>